var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _vm.showSteppeds
        ? _c(
            "div",
            { staticClass: "stepper__container" },
            [
              _c("div", { staticClass: "progress-header" }, [
                _c("div", { staticClass: "stepper__header__title" }, [
                  _c("h3", { staticClass: "stepper__title" }, [
                    _c(
                      "a",
                      {
                        staticClass: "stepper__return-step",
                        on: { click: _vm.exit }
                      },
                      [
                        _c("i", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isMovil,
                              expression: "isMovil"
                            }
                          ],
                          staticClass: "icon-ic-back-header"
                        })
                      ]
                    ),
                    _vm._v("Afiliar Comercio")
                  ]),
                  _c(
                    "a",
                    { staticClass: "stepper__prev", on: { click: _vm.exit } },
                    [
                      _vm._v("Salir"),
                      _c("save-afiliation", {
                        ref: "saveAffiliationModal",
                        on: {
                          dontSaveData: function($event) {
                            _vm.$refs.notAffiliationFinalizedModal.showModal()
                          },
                          saveData: _vm.saveAffiliationProcess,
                          closeWithoutSave: _vm.closeWithoutSaveAffiliation
                        }
                      }),
                      _c("not-affiliation-finalized", {
                        ref: "notAffiliationFinalizedModal",
                        on: {
                          return: _vm.returnModal,
                          saveData: _vm.saveAffiliationWorked
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("progress-movil", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isMovil,
                    expression: "isMovil"
                  }
                ],
                attrs: { step: _vm.step }
              }),
              _vm.$isPosFijoInternet() || _vm.$isPosInalambrico()
                ? _c(
                    "v-stepper",
                    {
                      staticClass: "elevation-0",
                      attrs: { "alt-labels": "" },
                      model: {
                        value: _vm.step,
                        callback: function($$v) {
                          _vm.step = $$v
                        },
                        expression: "step"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isMovil,
                              expression: "!isMovil"
                            }
                          ],
                          staticClass: "elevation-0"
                        },
                        [
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "1", complete: "" } },
                            [_vm._v("Validación de RUC/RUS")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "2", complete: "" } },
                            [_vm._v("Datos del representante")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "3", complete: "" } },
                            [_vm._v("Datos del Negocio")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "4", complete: "" } },
                            [_vm._v("Contactos del comercio")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "5", complete: "" } },
                            [_vm._v("Datos de cuenta bancaria")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "6", complete: "" } },
                            [_vm._v("Requisitos de afiliación")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "7", complete: "" } },
                            [_vm._v("Resumen de afiliación")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "8", complete: "" } },
                            [_vm._v("Envío de términos")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-items",
                        { staticClass: "elevation-0" },
                        [
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "1" } },
                            [_c("ruc-validations")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "2" } },
                            [_c("representative-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "3" } },
                            [_c("business-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "4" } },
                            [_c("installation-schedule")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "5" } },
                            [_c("bank-account-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "6" } },
                            [_c("membership-requirements")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "7" } },
                            [_c("afilliation-summary")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "8" } },
                            [
                              _vm.multiAdress.length > 0
                                ? _c("termsmultiAdress")
                                : _vm.onHold
                                ? _c("on-hold-affiliation")
                                : _vm.registerStatus === "R"
                                ? _c("reject-affiliation")
                                : _c("terms")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$isCorresponsalia()
                ? _c(
                    "v-stepper",
                    {
                      staticClass: "elevation-0",
                      attrs: { "alt-labels": "" },
                      model: {
                        value: _vm.step,
                        callback: function($$v) {
                          _vm.step = $$v
                        },
                        expression: "step"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isMovil,
                              expression: "!isMovil"
                            }
                          ],
                          staticClass: "elevation-0"
                        },
                        [
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "1", complete: "" } },
                            [_vm._v("Validación de RUC/RUS")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "2", complete: "" } },
                            [_vm._v("Datos del representante")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "3", complete: "" } },
                            [_vm._v("Datos del Negocio")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "4", complete: "" } },
                            [_vm._v("Datos del Agente")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "5", complete: "" } },
                            [_vm._v("Contactos del comercio")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "6", complete: "" } },
                            [_vm._v("Datos de cuenta bancaria")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "7", complete: "" } },
                            [_vm._v("Requisitos de afiliación")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "8", complete: "" } },
                            [_vm._v("Resumen de afiliación")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "9", complete: "" } },
                            [_vm._v("Envío de términos")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-items",
                        { staticClass: "elevation-0" },
                        [
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "1" } },
                            [_c("ruc-validations")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "2" } },
                            [_c("representative-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "3" } },
                            [_c("business-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "4" } },
                            [_c("agent-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "5" } },
                            [_c("installation-schedule")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "6" } },
                            [_c("bank-account-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "7" } },
                            [_c("membership-requirements")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "8" } },
                            [_c("afilliation-summary")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "9" } },
                            [
                              _vm.multiAdress.length > 0
                                ? _c("termsmultiAdress")
                                : _vm.onHold
                                ? _c("on-hold-affiliation")
                                : _vm.registerStatus === "R"
                                ? _c("reject-affiliation")
                                : _c("terms")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$isPagoWeb() || _vm.$isPagoApp()
                ? _c(
                    "v-stepper",
                    {
                      staticClass: "elevation-0",
                      attrs: { "alt-labels": "" },
                      model: {
                        value: _vm.step,
                        callback: function($$v) {
                          _vm.step = $$v
                        },
                        expression: "step"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isMovil,
                              expression: "!isMovil"
                            }
                          ],
                          staticClass: "elevation-0"
                        },
                        [
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "1", complete: "" } },
                            [_vm._v("Validación de RUC/RUS")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "2", complete: "" } },
                            [_vm._v("Datos del representante")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "3", complete: "" } },
                            [_vm._v("Datos del Negocio")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "4", complete: "" } },
                            [_vm._v("Datos de cuenta bancaria")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "5", complete: "" } },
                            [_vm._v("Requisitos de afiliación")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "6", complete: "" } },
                            [_vm._v("Datos de comercio virtual")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "7", complete: "" } },
                            [_vm._v("Registro a plataforma")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "8", complete: "" } },
                            [_vm._v("Resumen de afiliación")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "9", complete: "" } },
                            [_vm._v("Envío de términos")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-items",
                        { staticClass: "elevation-0" },
                        [
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "1" } },
                            [_c("ruc-validations")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "2" } },
                            [_c("representative-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "3" } },
                            [_c("business-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "4" } },
                            [_c("bank-account-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "5" } },
                            [_c("membership-requirements")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "6" } },
                            [_c("virtual-commerce-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "7" } },
                            [_c("register-plataform")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "8" } },
                            [_c("afilliation-summary-virtual")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "9" } },
                            [
                              _vm.multiAdress.length > 0
                                ? _c("termsmultiAdress")
                                : _vm.onHold
                                ? _c("on-hold-affiliation")
                                : _vm.registerStatus === "R"
                                ? _c("reject-affiliation")
                                : _c("terms")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.$isPagoLink()
                ? _c(
                    "v-stepper",
                    {
                      staticClass: "elevation-0",
                      attrs: { "alt-labels": "" },
                      model: {
                        value: _vm.step,
                        callback: function($$v) {
                          _vm.step = $$v
                        },
                        expression: "step"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isMovil,
                              expression: "!isMovil"
                            }
                          ],
                          staticClass: "elevation-0"
                        },
                        [
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "1", complete: "" } },
                            [_vm._v("Validación de RUC/RUS")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "2", complete: "" } },
                            [_vm._v("Datos del representante")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "3", complete: "" } },
                            [_vm._v("Datos del Negocio")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "4", complete: "" } },
                            [_vm._v("Datos de cuenta bancaria")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "5", complete: "" } },
                            [_vm._v("Requisitos de afiliación")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "6", complete: "" } },
                            [_vm._v("Registro a plataforma")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "7", complete: "" } },
                            [_vm._v("Resumen de afiliación")]
                          ),
                          _c("v-divider"),
                          _c(
                            "v-stepper-step",
                            { attrs: { step: "8", complete: "" } },
                            [_vm._v("Envío de términos")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-stepper-items",
                        { staticClass: "elevation-0" },
                        [
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "1" } },
                            [_c("ruc-validations")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "2" } },
                            [_c("representative-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "3" } },
                            [_c("business-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "4" } },
                            [_c("bank-account-data")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "5" } },
                            [_c("membership-requirements")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "6" } },
                            [_c("register-plataform")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "7" } },
                            [_c("afilliation-summary-virtual")],
                            1
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "8" } },
                            [
                              _vm.multiAdress.length > 0
                                ? _c("termsmultiAdress")
                                : _vm.onHold
                                ? _c("on-hold-affiliation")
                                : _vm.registerStatus === "R"
                                ? _c("reject-affiliation")
                                : _c("terms")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _c("product-choice"),
      _c("loader", { ref: "loader", attrs: { text: _vm.loaderMessage } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4695822", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4695822","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/new-affiliation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d4695822","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/new-affiliation.vue
// module chunks = 2